import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-terms-config',
  templateUrl: 'terms-config.component.html',
  styleUrls: ['terms-config.component.scss']
})
export class TermsConfigComponent implements OnInit {
  @Input() item: any;
  @Input() layout: number;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  termStyle: string;
  isFullscreen: boolean = false;
  currentField: 'privacy' | 'use' = 'use';

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'header': [1, 2, 3, false] }],
      [{ 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],
      ['link', 'clean']
    ]
  };

  quillFullscreenConfig = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      ['blockquote', 'code-block'],
      ['link', 'clean']
    ]
  };

  constructor() {
  }

  ngOnInit() {
    console.log('ITEM ->', this.item);
    if (Array.isArray(this.item.url)) {
      if (this.item.url.length <= 0) {
        this.item.url = [];
      }
    } else {
      this.item.url = [];
    }

    if (typeof this.item.termStyle === 'undefined') {
      this.item.termStyle = 'privacy';
    }

    if (typeof this.item.appUseTerm === 'undefined') {
      this.item.appUseTerm = '';
    }

    if (typeof this.item.appPrivacyTerm === 'undefined') {
      this.item.appPrivacyTerm = '';
    }
  }

  openFullscreen(field: 'privacy' | 'use') {
    this.currentField = field;
    this.isFullscreen = true;
  }

  closeFullscreen() {
    this.isFullscreen = false;
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

  getPhoto($event: any): void {
    this.item.favicon = $event.path;
  }

}
